import React from 'react';
import './portfolio-style/homepage.css'
import {PortfolioHeader} from "./portfolio-header";
import {FirstScreen} from "./first-screen";

export const PortfolioHomepage =()=> {
    return (
        <div className='portfolio-new-homepage'>
            <PortfolioHeader/>
            <a
                href="mailto:prakashtiwari27@outlook.com"
                className="floating-hire-btn"
            >
                Hire Me
            </a>

            <FirstScreen/>
        </div>
    );
};